module.exports = __webpack_public_path__ + "static/media/wolframalpha.ac304980.svg";